<template>
  <div>
    
    <div class="card">
      <div class="card-header">
        Basic Account Information
      </div>
      <div class="card-body">
        <p>
          Below is the basic account information we have on file - if any corrections are needed please contact us.
        </p>
        <div class="bd-example">
          <dl class="row">
            <dt class="col-sm-3">Account Name</dt>
            <dd class="col-sm-9">
              {{ accountLabel }}
            </dd>

            <dt class="col-sm-3">Address Line 1</dt>
            <dd class="col-sm-9">
              {{ addressLine1 }}
            </dd>

            <dt class="col-sm-3">Address Line 2</dt>
            <dd class="col-sm-9">
              {{ addressLine2 }}
            </dd>

            <dt class="col-sm-3">City</dt>
            <dd class="col-sm-9">
              {{ city }}
            </dd>

            <dt class="col-sm-3">Province / State</dt>
            <dd class="col-sm-9">
              {{ state }}
            </dd>

            <dt class="col-sm-3">Postal Code</dt>
            <dd class="col-sm-9">
              {{ postalCode }}
            </dd>

            <dt class="col-sm-3">Country</dt>
            <dd class="col-sm-9">
              {{ country }}
            </dd>

            <dt class="col-sm-3">Primary Phone Number</dt>
            <dd class="col-sm-9">
              {{ telephone }}
            </dd>

          </dl>
        </div>
        
      </div>
    <div>

    <CRow>
      <CCol sm="12">
        <CTableWrapper
          :items="childAccounts"
          hover
          striped
          bordered
          small
          fixed
          caption="Child Accounts"
        />
      </CCol>
    </CRow>
      </div>
    </div>
  </div>
</template>

<script>
import CTableWrapper from './ChildAccountTable.vue'
export default {

  name: 'AccountInfo',
  components: { CTableWrapper },
  

  data() {
    
    return {
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      postalCode: "",
      accountLabel: "",
      country: "",
      telephone: "",
      childAccounts: [],
    }
  },
  mounted: function () {
      this.getAccountInfo()
      this.getAccountChildAccounts()
    },
    methods: {
      getAccountInfo: function () {
        var self = this;
       this.$http
        .get(this.$apiUrl + "/v1/account", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("session_id")
          }
        })
        .then(function (response) {
      //    console.log(JSON.stringify(response))
          self.addressLine1 = response.data.address1_line1;
          self.accountLabel = response.data.name;
          self.addressLine2 = response.data.address1_line2;
          self.city = response.data.address1_city;
          self.state = response.data.address1_stateorprovince;
          self.postalCode = response.data.address1_postalcode;
          self.telephone = response.data.telephone1;
          self.country = response.data.address1_country;
     //     this.courses = JSON.stringify(response.data)
        })
        .catch(function (error) {
          console.log(error)
        })
      }, 
      getAccountChildAccounts: function () {
        var self = this;
       this.$http
        .get(this.$apiUrl + "/v1/account/childern", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("session_id")
          }
        })
        .then(function (response) {
          console.log(JSON.stringify(response))
          self.childAccounts = response.data;
        })
        .catch(function (error) {
          console.log(error)
        })
        
      },
    }
  

}

 
</script>